// SuccessPage.js
import React from 'react';

const SuccessPage = () => {
  return (
    <div style={{ 
      display: 'flex', 
      height: '100vh', 
      alignItems: 'center', 
      justifyContent: 'center', 
      flexDirection: 'column',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1>🎉 Login Successful!</h1>
      <p>Welcome back! You’re now signed in with Google.</p>
    </div>
  );
};

export default SuccessPage;